import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { getClassNames } from "@/shared/utils";
import { DocumentIcon } from "@/shared/icons";
import type { AppTablePropsImproved, TableItem } from "./types/table";
import { useChangeEvent } from "./hooks/use-change-event";
import { usePagination } from "./hooks/use-pagination";
import styles from "./styles/styles.module.scss";

export const AppTableImproved = <T extends TableItem>(props: AppTablePropsImproved<T>) => {
  const { t } = useTranslation();

  const {
    isPaginationVisible = true,
    onTotalPagesChange,
    tableRef,
    noDataMessage = t("common.noData"),
    ...rest
  } = props;

  const className = getClassNames(rest.className);
  const pagination = usePagination(rest.pagination, onTotalPagesChange);
  const onChange = useChangeEvent<T>(pagination, rest.onChange);
  const locale = {
    emptyText: (
      <div className={styles.empty}>
        <DocumentIcon />
        <p>{noDataMessage}</p>
      </div>
    ),
  };

  return (
    <div className={styles["table-wrapper"]}>
      <Table
        ref={tableRef}
        locale={locale}
        rowClassName={getRowClass(props)}
        {...rest}
        pagination={isPaginationVisible && pagination}
        onChange={onChange}
        className={className}
      />
    </div>
  );
};

const getRowClass = <T,>(props: AppTablePropsImproved<T>): string => {
  return props.onRow ? "clickable-row" : "";
};
